<template>
  <v-app id="inspire">
    <v-app id="inspire">
      <v-navigation-drawer
        v-model="drawer"
        app
      >
        <v-list dense>

          <v-list-item 
            link
            v-for="route in routes"
            :key="route.name"
            :to="route.path"
          >
            <v-list-item-action>
              <v-icon>{{route.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{route.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          
        </v-list>
      </v-navigation-drawer>
  
      <v-app-bar
        app
        color="blue-grey darken-2"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title >CassiaProject</v-toolbar-title>
      </v-app-bar>
  
      <v-main>
        <v-container
          fluid
        >
           <router-view></router-view>

        </v-container>
      </v-main>
      <v-footer
        color="blue-grey darken-2"
        app
      >
        <span class="white--text">&copy; Cassiasoft 2020</span>
      </v-footer>
    </v-app>
  </v-app>
</template>

<script>

  import { mapActions } from 'vuex';
  
  import fb from '@/firebaseConfig'

  

export default {
  

  name: 'App',

  components: {
    
  },

  data: () => ({
    
    drawer: null,
    initial: true

  }),

  computed: {
    
    routes() { return this.$router.options.routes.filter(route => route.menu) } 

  },

  methods:{
      ...mapActions(['createTeam','readTeam','updateTeam','deleteTeam',
                     'createDemands','readDemands','updateDemands','deleteDemands',
                     'createPlanning','readPlanning','updatePlanning','deletePlanning',
      ])
  },

  created () {
    
    let initialTeamCollection = true;
    fb.teamCollection.onSnapshot(res => {
        
        let newItems = [];
        const changes = res.docChanges();
    
        changes.forEach(change => {

            let docData = change.doc.data();
            docData.id = change.doc.id;

            switch (change.type) {
              case 'added': initialTeamCollection ? newItems.push(docData) : this.createTeam(docData) ; break;
              case 'removed': this.deleteTeam(docData.id); break;
              case 'modified': this.updateTeam(docData); break;
              default: break;
            }
            
        })

        if (initialTeamCollection === true) {
          this.readTeam(newItems);
          initialTeamCollection = false;
        }

    })


    
    let initialDemandsCollection = true;
    fb.demandsCollection.onSnapshot(res => {
        
        let newItems = [];
        const changes = res.docChanges();
    
        changes.forEach(change => {

            let docData = change.doc.data();
            docData.id = change.doc.id;

            switch (change.type) {
              case 'added': initialDemandsCollection ? newItems.push(docData) : this.createDemands(docData) ; break;
              case 'removed': this.deleteDemands(docData.id); break;
              case 'modified': this.updateDemands(docData); break;
              default: break;
            }
            
        })

        if (initialDemandsCollection === true) {
          this.readDemands(newItems);
          initialDemandsCollection = false;
        }

    })

    let initialPlanningCollection = true;
    fb.planningCollection.onSnapshot(res => {
        
        let newItems = [];
        const changes = res.docChanges();
    
        changes.forEach(change => {

            let docData = change.doc.data();
            docData.id = change.doc.id;


            switch (change.type) {
              case 'added': initialPlanningCollection ? newItems.push(docData) : this.createPlanning(docData) ; break;
              case 'removed': this.deletePlanning(docData.id); break;
              case 'modified': this.updatePlanning(docData); break;
              default: break;
            }
            
        })

        if (initialPlanningCollection === true) {
          this.readPlanning(newItems);
          initialPlanningCollection = false;
        }

    })    

  }
}
</script>
